<div class="mb-0 p-4 border-0 text-center">
  <div class="p-0" mat-dialog-content>
    <p class="my-2 app-info"><strong>{{'Version' | translate}}: </strong>{{version_number}}</p>
    <p class="my-2 app-info"><strong>{{'Build' | translate}}: </strong>{{build_number}}</p>
    <mat-divider></mat-divider>
    <small class="d-block my-2 text-muted app-info">{{'Updated' | translate}} {{updated_at}}</small>
  </div>
  <div class="pt-2 pb-2 d-flex flex-column gap-2 justify-content-center align-items-center border-top">
    <button (click)="clearCache()" mat-button color="warn" class="mt-2">{{'Clear cache' | translate}}</button>
    <button (click)="checkForUpdates()" mat-button color="primary" class="blue">
      {{'Check for updates' | translate}}
      @if (loading) {
        <div class="spinner-border spinner-border-sm text-light ml-2" role="status"></div>
      }
    </button>
    @if (appUpdateStatus) {
      <button (click)="reload()" mat-button color="accent" class="primary">
        {{'A newer version is available. Click to reload' | translate}}
      </button>
    }
    <button mat-button color="default" (click)="closeDialog()">
      {{ 'Close' | translate }}
    </button>
  </div>
</div>

